const BACKGROUND_IMAGE_TOKEN_TO_CLASS = {
  'Fill screen': 'bg-image--fill-screen',
  'Fit to screen': 'bg-image--fit-to-screen',
  Original: 'bg-image--original',
  Repeat: 'bg-image--repeat',
  None: 'bg-image--none',
} as const;

const BACKGROUND_IMAGE_MOBILE_TOKEN_TO_CLASS = {
  'Fill screen': 'bg-image-mobile--fill-screen',
  'Fit to screen': 'bg-image-mobile--fit-to-screen',
  Original: 'bg-image-mobile--original',
  Repeat: 'bg-image-mobile--repeat',
  None: 'bg-image-mobile--none',
} as const;

export type BackgroundImageToken = keyof typeof BACKGROUND_IMAGE_TOKEN_TO_CLASS;

export type BackgroundImageMobileToken =
  | BackgroundImageToken
  | 'Same as desktop';

type ResolveBackgroundImageTokenOptions = {
  mobile?: boolean;
};

export const resolveBackgroundImageToken = (
  token?: string | null,
  options?: ResolveBackgroundImageTokenOptions,
): string => {
  if (options?.mobile) {
    if (!token || token === 'Same as desktop') {
      return '';
    }

    return (
      BACKGROUND_IMAGE_MOBILE_TOKEN_TO_CLASS[token as BackgroundImageToken] ??
      ''
    );
  }

  if (!token) {
    return BACKGROUND_IMAGE_TOKEN_TO_CLASS['Fill screen'];
  }

  return (
    BACKGROUND_IMAGE_TOKEN_TO_CLASS[token as BackgroundImageToken] ??
    BACKGROUND_IMAGE_TOKEN_TO_CLASS['Fill screen']
  );
};
